'use client'
import { InputAdornment, OutlinedInput } from '@mui/material'
import { Search } from 'react-feather'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
export function SearchBox() {
  const { query, push } = useAppRouter()
  const handleSubmit = (e) => {
    const value = e.target.value
    if (value === '' || value === undefined) {
      return
    }
    const url = new URLSearchParams(query)
    if (url.get('search') === value) {
      return
    }
    url.set('search', value)
    push(`/learn/search?${url.toString()}`)
  }

  return (
    <div className={'[&_input]:px-4 [&_input]:py-1  w-full lg:w-3/12'}>
      <OutlinedInput
        id="outlined-adornment-amount"
        startAdornment={
          <InputAdornment position="start">
            <Search size={16} />
          </InputAdornment>
        }
        size="small"
        fullWidth
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(e)
          }
        }}
        onBlur={(e) => {
          handleSubmit(e)
        }}
        placeholder="Search"
        aria-label="search"
      />
    </div>
  )
}

export default SearchBox
